import React from 'react';
import { Container, Typography, Box, List, ListItem, ListItemText } from '@mui/material';
import { theme } from '../styles/theme';

const ShippingPolicy = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: theme.palette.background.default }}>
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Typography variant="h2" component="h1" align="center" sx={{ color: theme.palette.primary.main, mb: 4 }}>
          Shipping Policy
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 3 }}>
          At Yogi Plus Water Tank, we strive to provide efficient and reliable shipping services to ensure you receive your water tank in perfect condition. Below are our shipping policies and procedures:
        </Typography>

        {/* Section 1: Shipping Areas */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          1. Shipping Areas
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          We currently ship to:
        </Typography>
        <List sx={{ ml: 2, listStyleType: 'disc' }}>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText
              primary="India"
              secondary="Nationwide shipping available to all major cities and towns across India."
            />
          </ListItem>
        </List>

        {/* Section 2: Shipping Methods */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          2. Shipping Methods
        </Typography>
        <List sx={{ ml: 2, listStyleType: 'decimal' }}>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText
              primary="Standard Shipping"
              secondary="Free shipping on orders above ₹10,000. Delivery within 7-15 business days depending on location."
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText
              primary="Express Shipping"
              secondary="Available for an additional fee. Delivery within 3-7 business days."
            />
          </ListItem>
        </List>

        {/* Section 3: Delivery Time */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          3. Delivery Time
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Delivery times may vary based on:
        </Typography>
        <List sx={{ ml: 2, listStyleType: 'disc' }}>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText
              primary="Your location"
              secondary="Delivery times may vary depending on your city and state."
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText
              primary="Product availability"
              secondary="Some products may require additional processing time."
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText
              primary="Shipping method"
              secondary="Standard vs Express shipping options."
            />
          </ListItem>
        </List>

        {/* Section 4: Shipping Charges */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          4. Shipping Charges
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Shipping charges are calculated based on:
        </Typography>
        <List sx={{ ml: 2, listStyleType: 'disc' }}>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText
              primary="Product weight and dimensions"
              secondary="Larger or heavier items may incur higher shipping costs."
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText
              primary="Shipping destination"
              secondary="Delivery to remote areas may have additional charges."
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText
              primary="Shipping method"
              secondary="Express shipping incurs additional charges."
            />
          </ListItem>
        </List>

        {/* Section 5: Delivery Installation */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          5. Delivery and Installation
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          We offer professional installation services for our water tanks. Please contact our customer support for more information about installation services and fees.
        </Typography>
      </Container>
    </Box>
  );
};

export default ShippingPolicy;
